// extracted by mini-css-extract-plugin
module.exports = {"bgHeaderBackground":"Error_bgHeaderBackground__1Is67","errorDescription":"Error_errorDescription__2Y0-B","linkStyle":"Error_linkStyle__41bt4"};